























import Vue from 'vue';
import Arrow from '@/components/common/icons/Arrow.vue';
import { EArrowDirection } from '@/common/enums/index.enum';
import { IBar } from '@/common/interfaces/announcement-bar.interface';

export default Vue.extend({
  name: `InfoBar`,
  components: { Arrow },
  computed: {
    arrowDirection(): string {
      return EArrowDirection.RIGHT;
    },
    contentStyle(): string {
      return `color: ${this.infoBar.textColor};`;
    },
  },
  props: {
    infoBar: {
      required: true,
      type: Object as () => IBar,
    },
  },
  methods: {
    checkIfInternalOrExternal(link: string): string {
      return link.substring(0, 1) === `/` ? `_self` : `_blank`;
    },
  },
});
